import { Box, Divider, FlexBox } from '@dixa/lib-shared-habla';
import { MetaConversation } from 'lib-shared-legacy-types';
import type { Conversation, SearchConversationHit } from 'lib-shared-types-api';

import { ConversationStatusColorBox } from 'components/conversation';

import { ConversationPreviewActions } from './components/actions/conversationPreviewActions';
import { ConversationPreviewCustomFields } from './components/customFields/conversationPreviewCustomFields';
import { ConversationPreviewHeadline } from './components/headline/conversationPreviewHeadline';
import { ConversationPreviewTags } from './components/tags/conversationPreviewTags';
import styles from './conversationPreviewHeader.module.scss';

type ConversationPreviewHeaderProps = {
  csid: number;
  metaConversation: MetaConversation;
  highlights: SearchConversationHit['_highlights'];
  onPreviewClose: () => void;
  onGoToConversation: () => void;
};

export const ConversationPreviewHeader = ({
  csid,
  metaConversation,
  highlights,
  onPreviewClose,
  onGoToConversation,
}: ConversationPreviewHeaderProps): JSX.Element => {
  const conversation = metaConversation.conversation as Conversation;

  return (
    <>
      <FlexBox flexDirection="row">
        <ConversationStatusColorBox
          csid={conversation.id}
          status={conversation.status}
        />

        <Box className={styles.content} flex="1" padding="300 400">
          <ConversationPreviewHeadline
            metaConversation={metaConversation}
            highlights={highlights}
          />

          <ConversationPreviewActions
            onGoToConversation={onGoToConversation}
            onClose={onPreviewClose}
            metaConversation={metaConversation}
            csid={csid}
          />

          <ConversationPreviewTags
            tags={metaConversation.conversation.tags ?? []}
            showSectionIcon
          />

          {typeof metaConversation.conversation.id === 'number' && (
            <ConversationPreviewCustomFields
              csid={metaConversation.conversation.id}
              showSectionIcon
            />
          )}
        </Box>
      </FlexBox>

      <Divider />
    </>
  );
};
